import { render, staticRenderFns } from "./AnnexesList.vue?vue&type=template&id=15a266e2&scoped=true"
import script from "./AnnexesList.vue?vue&type=script&lang=js"
export * from "./AnnexesList.vue?vue&type=script&lang=js"
import style0 from "./AnnexesList.vue?vue&type=style&index=0&id=15a266e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a266e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a266e2')) {
      api.createRecord('15a266e2', component.options)
    } else {
      api.reload('15a266e2', component.options)
    }
    module.hot.accept("./AnnexesList.vue?vue&type=template&id=15a266e2&scoped=true", function () {
      api.rerender('15a266e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/detail/components/CustomModules/AnnexesList.vue"
export default component.exports